export default "__VITE_ASSET__CnqeD7dd__"